import React, { useMemo, useState } from "react";
import ListTable from "../../common/ListTable";
import CustomFilter from "../Common/CustomFilter";

const BuyerListTable = (props) => {
  const {
    total,
    loading,
    defaultCurrent,
    pageSize,
    current,
    onChange,
    showFilter,
    setShowFilter,
  } = props;

  const handleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const memoizedCustomFilter = useMemo(
    () => (
      <CustomFilter
        showFilter={showFilter}
        tableData={props.dataSource}
        fetchTableData={null}
        filterName="buying_office"
      />
    ),
    [showFilter, props.dataSource],
  );

  return (
    <>
      {props.filter && memoizedCustomFilter}
      <div className="table" style={{ marginTop: 10 }}>
        <ListTable
          loading={loading}
          emptyText="No records to show yet."
          pagination={{
            showSizeChanger: false,
            defaultPageSize: pageSize,
            current: current,
            onChange: onChange,
            defaultCurrent: defaultCurrent,
            total: total,
          }}
          columns={props.tableColumns}
          dataSource={props.dataSource}
        />
      </div>
    </>
  );
};
export default BuyerListTable;
